import createIcon from '../../createIcon';

/**
 * @component @name ClearAll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxM0gxOVYxMUg1VjEzWk0zIDE3SDE3VjE1SDNWMTdaTTcgN1Y5SDIxVjdIN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ClearAll = createIcon('ClearAll', [
  ['path', { d: 'M5 13H19V11H5V13ZM3 17H17V15H3V17ZM7 7V9H21V7H7Z', key: '15tdw8' }],
]);

export default ClearAll;
